import { Address } from '../core/address.type';

export interface MembershipCardholder {
  id?: number;
  customerId?: number;
  membershipId?: number;
  primaryCard?: 'yes' | 'no';
  cardType: 'primary' | 'secondary';
  cardStatus?: 'new' | 'active' | 'dropped' | 'lapsed' | 'noMembership' | 'replaced';
  cardImportId?: string;
  constituentId?: string;
  address?: Address;
  prefix?: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  customerSource: string;
  expirationDate?: string;
  startDate?: string;
  addressId?: number;
  streetAddress1?: string;
  streetAddress2?: string;
  state?: string;
  city?: string;
  country?: string;
  zipCode?: string;
}

export function isPrimaryCardholder(cardholder: MembershipCardholder) {
  return cardholder.cardType.toLowerCase() === 'primary' || cardholder.primaryCard?.toLowerCase() === 'yes';
}

export function isSecondaryCardholder(cardholder: MembershipCardholder) {
  return isPrimaryCardholder(cardholder) === false;
}

export function extractEmbeddedAddressFromCardholder(cardholder: MembershipCardholder): Address {
  return {
    id: cardholder.addressId,
    streetAddress1: cardholder.streetAddress1 ?? '',
    streetAddress2: cardholder.streetAddress2,
    state: cardholder.state ?? '',
    city: cardholder.city ?? '',
    country: cardholder.country ?? '',
    zipCode: cardholder.zipCode ?? '',
  };
}
